document.addEventListener("DOMContentLoaded", () => {
    const tabHeadings = document.querySelectorAll(".sub-tabs .h7");
    const tabContents = [".cat-letter-sec2", ".sub-sec6", ".cat-letter-sec3", ].map(selector => document.querySelector(selector));
    tabHeadings.forEach((heading, index) =>
      heading.addEventListener("click", () => {
        tabHeadings.forEach(h => h.classList.remove("active"));
        tabContents.forEach(c => c.classList.remove("active"));
        heading.classList.add("active");
        tabContents[index].classList.add("active");
      })
    );
  });
  